<template>
  <div class="space">
    <Icon type="space" />
    <span>{{ $t('com_msg_empty') }}</span>
  </div>
</template>
<script>
export default {
  props: {},
};
</script>
<style lang="less" scoped>
.space {
  border: #eee dashed 1px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  color: #ddd;
  background: #f9f9f9;
  position: relative;
  min-width: 120px;
  min-height: 120px;
  .icon {
    width: 60px;
    height: 60px;
  }
  span {
    position: absolute;
    left: 0%;
    top: 70%;
    width: 100%;
    text-align: center;
    font-weight: normal;
    font-size: 16px;
  }
}
</style>
